import {Injectable, PLATFORM_ID, Inject} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {get_school_id} from "./school.service";

@Injectable({providedIn: 'root'})
export class UserService {

	profile_image_url = null;
	display_name = null;
	email = null;
	user_role = null;

	is_admin = false;
	private isBrowser: boolean;

	constructor(
		@Inject(PLATFORM_ID) platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(platformId);
		this.init();
	}

	init() {
		if (!this.isBrowser) return;
		
		this.profile_image_url = localStorage.getItem(this.storage_keys.profile_image_url) || null;
		this.display_name = localStorage.getItem(this.storage_keys.display_name) || null;
		this.email = localStorage.getItem(this.storage_keys.email) || null;
		this.user_role = localStorage.getItem(this.storage_keys.user_role) || null;

		if (this.profile_image_url === 'null') {
			this.profile_image_url = null;
		}
	}

	get storage_keys() {
		let school_id = get_school_id();
		if (this.is_admin) {
			return {
				profile_image_url: `admin_user_${school_id}_profile_image_url`,
				display_name: `admin_user_${school_id}_display_name`,
				email: `admin_user_${school_id}_email`,
				user_role: `admin_user_${school_id}_user_role`,
			}
		}
		return {
			profile_image_url: `user_${school_id}_profile_image_url`,
			display_name: `user_${school_id}_display_name`,
			email: `user_${school_id}_email`,
			user_role: `user_${school_id}_user_role`,
		}
	}

	set_display_name(display_name) {
		this.display_name = display_name;
		if (this.isBrowser) {
			localStorage.setItem(this.storage_keys.display_name, display_name);
		}
	}

	set_profile_image_url(profile_image_url) {
		this.profile_image_url = profile_image_url;
		if (this.isBrowser) {
			localStorage.setItem(this.storage_keys.profile_image_url, profile_image_url);
		}
	}

	set_email(email) {
		this.email = email;
		if (this.isBrowser) {
			localStorage.setItem(this.storage_keys.email, email);
		}
	}

	set_user_role(user_role) {
		this.user_role = user_role;
		if (this.isBrowser) {
			localStorage.setItem(this.storage_keys.user_role, user_role);
		}
	}

	clear_data() {
		if (this.isBrowser) {
			localStorage.removeItem(this.storage_keys.profile_image_url);
			localStorage.removeItem(this.storage_keys.display_name);
			localStorage.removeItem(this.storage_keys.email);
			localStorage.removeItem(this.storage_keys.user_role);
		}
		this.profile_image_url = null;
		this.display_name = null;
		this.email = null;
		this.user_role = null;
	}
}